import { useAuth } from '@/context';
import { usePermissions } from '@/hooks/usePermissions';
import { checkRoutePermission } from '@/constants/permissions';
import PageLoader from '@/components/PageLoader';
import PermissionDeniedPage from '@/pages/PermissionDenied/PermissionDeniedPage';
import PublicLayout from '@/layouts/PublicLayout/PublicLayout';
import AdminLayout from '@/layouts/AdminLayout/AdminLayout';

function AdminModuleGate({ permission, adminComponent: AdminComponent, publicComponent: PublicComponent }) {
  const { isAuthenticated, isLoading } = useAuth();
  const { permissions, hasPermission } = usePermissions();

  if (isLoading) {
    return <PageLoader message="Loading..." />;
  }

  if (isAuthenticated && hasPermission(permission.module, permission.action)) {
    if (!checkRoutePermission(permissions, permission)) {
      return (
        <AdminLayout>
          <PermissionDeniedPage />
        </AdminLayout>
      );
    }

    return (
      <AdminLayout>
        <AdminComponent />
      </AdminLayout>
    );
  }

  return (
    <PublicLayout>
      <PublicComponent />
    </PublicLayout>
  );
}

export function PortalTournamentsRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'tournaments', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}

export function PortalTeamsRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'tournaments', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}

export function PortalPlayersRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'tournaments', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}

export function PortalGroundsRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'grounds', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}

export function PortalGalleryRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'sponsors', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}

export function PortalSponsorsRoute({ publicComponent: PublicComponent, adminComponent: AdminComponent }) {
  return (
    <AdminModuleGate
      permission={{ module: 'sponsors', action: 'read' }}
      adminComponent={AdminComponent}
      publicComponent={PublicComponent}
    />
  );
}
